export const ADD_ADVERTISEMENT_START = 'ADD_ADVERTISEMENT_START';
export const ADD_ADVERTISEMENT_SUCCESS = 'ADD_ADVERTISEMENT_SUCCESS';
export const ADD_ADVERTISEMENT_ERROR = 'ADD_ADVERTISEMENT_ERROR';
